export const vyTypography = {
  fontFamily: 'Inter, sans-serif',
};
